import { doc, getDoc, serverTimestamp, setDoc } from 'firebase/firestore';
import { db } from './firebase';

const COLLECTION = 'commissionSettings';
const DOCUMENT_ID = 'global';

export class CommissionService {
    static async getSettings() {
        try {
            const ref = doc(db, COLLECTION, DOCUMENT_ID);
            const snapshot = await getDoc(ref);

            if (!snapshot.exists()) {
                return null;
            }

            const data = snapshot.data();
            return data.settings ?? null;
        } catch (error) {
            console.error("Error getting commission settings:", error);
            return null;
        }
    }

    static async saveSettings(settings) {
        const ref = doc(db, COLLECTION, DOCUMENT_ID);
        await setDoc(
            ref,
            {
                settings,
                updatedAt: serverTimestamp(),
            },
            { merge: true }
        );
    }
}
